
// import ReactGA from 'react-ga';
import tracker from './tracker'
import log from '../../utils/console/log'
let trackableEvents = {};
let trackingStoppedAt = 0;
let windowWasInActive = false;
const {trackEvent}= tracker;
let addInactiveTimeToEvents = inActiveInterval => {
  Object.keys(trackableEvents).forEach((key) =>{
    trackableEvents[key] += inActiveInterval;
  });
};

const startTimer = (event) => {
  log(`tracker Started timer for ${event}` );
  trackableEvents[event] = Date.now();
}
const stopTimer = (event, options) =>{
  const timeTaken = Date.now() - (trackableEvents[event] || 0);
  delete trackableEvents[event];
  log(`tracker stopped timer for ${event} ${timeTaken} ${options}` );
  //Track the event timing
  const { category , action, label } =options;
  if (options) {
    trackEvent({
      category: category,
      action: action,
      label: label,
      value: timeTaken,
    });
  }
  return timeTaken;
}

const stopTracking = () =>{
  trackingStoppedAt = Date.now();
  windowWasInActive = true;
}

const startTracking = () =>{
  if (!windowWasInActive) {
    return false;
  }
  const inActiveInterval = Date.now() - trackingStoppedAt;
  trackingStoppedAt = 0;
  windowWasInActive = false;
  addInactiveTimeToEvents(inActiveInterval);
}

export default {
  startTimer,
  stopTimer,
  stopTracking,
  startTracking,
}